module.exports = __webpack_public_path__ + "img/42_30.521414ba.png";